import React from 'react';
import { setCurrentView } from 'core/utils';
import { AdjustAllSkusTemplate } from 'themes/modules/product-inventory/pages';
import { InventorySyncPageViewStore } from '../stores';

@setCurrentView(
	(rootStore, componentProps) => new InventorySyncPageViewStore(rootStore, componentProps),
	'inventorySyncPageViewStore'
)
class AdjustAllSkus extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <AdjustAllSkusTemplate {...this.props} />;
	}
}

export default AdjustAllSkus;



// WEBPACK FOOTER //
// ./src/modules/product-inventory/pages/AdjustAllSkus.jsx